export default "__VITE_ASSET__5780840a__"